import { Award, Cpu, ShieldCheck, ArrowRight, Stethoscope, Gift } from "lucide-react";

var ADVANTAGES = [
  { icon: Award, text: "Кандидат мед. наук с опытом 27 лет" },
  { icon: Cpu, text: "Цифровое 3D-планирование операций" },
  { icon: ShieldCheck, text: "Пожизненная гарантия на импланты" },
];

var UTP_ITEMS = [
  "Бесплатная консультация",
  "Снимок КТ",
  "Удаление зубов в подарок",
];

export default function HeroSection() {
  var scrollToQuiz = function () {
    var el = document.getElementById("quiz-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="pt-20 md:pt-28 pb-12 md:pb-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          {/* Text */}
          <div className="animate-fade-in-up order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-50 border border-brand-200 text-brand-700 text-sm font-medium mb-5">
              <Stethoscope className="w-4 h-4" />
              Санкт-Петербург
            </div>

            <h1 data-testid="hero-heading" className="font-heading text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight leading-tight mb-3">
              Забудьте о съёмных
              <br />
              протезах <span className="text-brand-600">навсегда</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-500 mb-5">
              Имплантация всех зубов под ключ
            </p>

            <div className="flex flex-wrap gap-2 mb-5">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-50 border border-slate-200 text-slate-700 text-sm font-medium">
                Для всех пациентов
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-sm font-medium">
                Индивидуальные условия для пенсионеров
              </span>
            </div>

            {/* UTP */}
            <div data-testid="hero-utp" className="flex flex-col gap-2 mb-6">
              {UTP_ITEMS.map(function (item) {
                return (
                  <div key={item} className="flex items-center gap-3 px-4 py-3 rounded-xl bg-brand-50 border border-brand-100">
                    <Gift className="w-5 h-5 text-brand-600 flex-shrink-0" />
                    <span className="text-sm sm:text-base font-medium">{item}</span>
                  </div>
                );
              })}
            </div>

            {/* Advantages */}
            <div className="flex flex-col gap-3 mb-8">
              {ADVANTAGES.map(function (adv) {
                var Icon = adv.icon;
                return (
                  <div key={adv.text} className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-brand-100 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-4 h-4 text-brand-600" />
                    </div>
                    <span className="text-base">{adv.text}</span>
                  </div>
                );
              })}
            </div>

            <button
              data-testid="hero-cta"
              onClick={scrollToQuiz}
              className="h-14 px-8 sm:px-10 text-base sm:text-lg font-medium rounded-full bg-brand-600 hover:bg-brand-700 text-white transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto cursor-pointer inline-flex items-center justify-center gap-2"
            >
              Рассчитать стоимость
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* Doctor photo */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <div className="relative w-full max-w-[320px] sm:max-w-[380px] lg:max-w-none">
              <div className="rounded-3xl overflow-hidden shadow-2xl border border-slate-100 bg-gradient-to-b from-brand-50 to-brand-100">
                <img
                  src="/images/doctor.png"
                  alt="Амир Резаевич Мошир — врач имплантолог"
                  className="w-full h-[300px] sm:h-[380px] lg:h-[460px] object-contain object-bottom"
                  loading="eager"
                />
              </div>
              <div className="absolute -bottom-4 left-2 sm:-bottom-5 sm:-left-4 bg-white rounded-2xl shadow-xl border border-slate-100 p-4 sm:p-5 max-w-[240px] sm:max-w-[260px]">
                <p className="font-semibold text-sm sm:text-base">Амир Резаевич Мошир</p>
                <p className="text-xs sm:text-sm text-slate-500 leading-snug mt-1">
                  Имплантолог, челюстно&#8209;лицевой хирург, к.м.н.
                </p>
                <p className="text-xs sm:text-sm font-semibold text-brand-600 mt-1">Опыт: 27 лет</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
